import React from "react";
import { useTranslation } from "react-i18next";
import { Button,   } from "@material-ui/core";
import useStyles from "./Export.style";

interface IExport {
  openExportModal(): void;
  closeModal?(): void;
}

const Export: React.FC<IExport> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation(["translation"]);

  const { openExportModal,  } = props;

  const handleClick = () => {
    openExportModal();
  };

  return (
    <Button
      variant="contained"
      className={classes.export}
      startIcon={<img src="/img/export.svg" alt="export" />}
      onClick={handleClick}
    >
      {t("translation:common.export")}
    </Button>
  );
};

export default Export;
